export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line

const dniRegex = /^([1-9][0-9]{6,7}|^[1-9][0-9]{10})$/; // Also validate 11 digits CUIL

export const patentRegex =
  /^(([a-zA-Z]{3}[ ]{0,1}[0-9]{3})|([a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2})|([0-9]{3}[ ]{0,1}[a-zA-Z]{3})|([a-zA-Z]{1}[0-9]{3}[a-zA-Z]{3}))$/;

export const areaCodeRegex = /^(?!0+$)[0-9]{2,5}$/;

export const numericalFourDigitsRegex = /^[0-9]{4}$/;

export const numericalElevenDigitsRegex = /^[0-9]{11}$/;

export const numericalDigitsRegex = /^([0-9]+)$/;

export const numericalBetweenSevenOrElevenDigitsRegex = /^(?!0+$)[0-9]{7,11}$/;

export const phoneRegex = /^(?!0+$)[0-9]{7,8}$/;

export const cellPhoneRegex = /^(?!15)+[0-9]{10}$/;

export const fullPhoneRegex = /^(?!0+$)[0-9]{8,13}$/;

export const alphaNumericValidationMask = /^[a-zA-Z0-9]*$/;

export const atLeastOneNumber = /[0-9]/;

export const atLeastOneLetter = /[a-zA-Z]/;

export const atLeastOneUppercaseLetter = /[A-Z]/;

export const notOnlySpaces = /\S/;

export const fullPhoneNumberRegex = /^[0-9]{3,6}-[0-9]{6,10}$/;

export const phoneNumberRegex =
  /^(?:(?:00)?549?)?0?(?:11|[2368]\d)(?:(?=\d{0,2}15)\d{2})??\d{8}$/;

export const nameRegex = /^([a-zA-ZÇ-Üá-úñÑ][ ]?)*$/;

export const required = (errorMessage) => (val) =>
  val ? undefined : errorMessage;

export const minLength = (minimumLength, errorMessage) => (val) =>
  val ? (val.length >= minimumLength ? undefined : errorMessage) : undefined;

export const maxLength = (maximumLength, errorMessage) => (val) =>
  val ? (val.length <= maximumLength ? undefined : errorMessage) : undefined;

export const pattern = (patternRegex, errorMessage) => (val) =>
  val ? (patternRegex.test(val) ? undefined : errorMessage) : undefined;

export const email = (errorMessage) => pattern(emailRegex, errorMessage);

export const numericalFourDigits = (errorMessage) =>
  pattern(numericalFourDigitsRegex, errorMessage);

export const numericalTenDigits = (errorMessage) =>
  pattern(numericalElevenDigitsRegex, errorMessage);

export const numericalBetweenSevenOrElevenDigits = (errorMessage) =>
  pattern(numericalBetweenSevenOrElevenDigitsRegex, errorMessage);

export const numericalDigits = (errorMessage) =>
  pattern(numericalDigitsRegex, errorMessage);

export const patent = (errorMessage) => pattern(patentRegex, errorMessage);

export const minOneNumber = (errorMessage) =>
  pattern(atLeastOneNumber, errorMessage);

export const minOneLetter = (errorMessage) =>
  pattern(atLeastOneLetter, errorMessage);

export const minOneUppercaseLetter = (errorMessage) =>
  pattern(atLeastOneUppercaseLetter, errorMessage);

export const fullPhoneNumber = (errorMessage) =>
  pattern(fullPhoneNumberRegex, errorMessage);

export const phoneNumber = (errorMessage) =>
  pattern(phoneNumberRegex, errorMessage);

export const name = (errorMessage) => pattern(nameRegex, errorMessage);

export const composeValidatorsNoRequired =
  (...validators) =>
  (value) =>
    validators.reduce(
      (error, validator) => (!value ? undefined : error || validator(value)),
      undefined
    );

export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined
    );

export const nRequired = (val) => (val ? undefined : 'Campo requerido');

export const validateDni = (dni) =>
  dniRegex.test(dni) ? undefined : 'Ingresá un número de documento válido';

export const validateLicensePlate = (licensePlate) =>
  patentRegex.test(licensePlate) ? undefined : 'Ingresá una patente válida';

// eslint-disable-next-line no-shadow
export const validateEmail = (email) =>
  emailRegex.test(email) ? undefined : 'Email inválido';

export const validateEmptyString = (str) =>
  notOnlySpaces.test(str) ? undefined : 'Ingresá un texto no vacío';

export const validateAreaCode = (code) =>
  areaCodeRegex.test(code) ? undefined : 'Ingresá un código de área válido';

export const validatePhone = (phone) =>
  phoneRegex.test(phone) ? undefined : 'Ingresá un teléfono válido';

export const validateCellPhone = (phone) =>
  cellPhoneRegex.test(phone) ? undefined : 'Ingresá el número sin 15';

export const validateFullPhone = (phone) =>
  fullPhoneRegex.test(phone) ? undefined : 'Ingresá un teléfono válido';

export const validateMatchPassword = ({
  password,
  passwordConfirmation,
  currentPassword,
}) => {
  const errors = {};

  if (!password) {
    errors['password'] = 'Campo requerido';
  }

  if (currentPassword && password && currentPassword === password) {
    errors['password'] = 'Debe elegir una contraseña diferente';
  }

  if (!passwordConfirmation) {
    errors['passwordConfirmation'] = 'Campo requerido';
  }

  if (password !== passwordConfirmation) {
    errors['passwordConfirmation'] = 'Las contraseñas no coinciden';
  }

  return errors;
};

export const validateLicensePlateByType = (type) => (licensePlate) => {
  let regex;

  switch (type) {
    case 'car':
      regex = /^[A-Z]{3}\d{3}$|^[A-Z]{2}\d{3}[A-Z]{2}$/;
      break;
    case 'trailer':
      regex = /^\d{3}[A-Z]{3}\d{3}$|^\d{3}[A-Z]{2}\d{3}[A-Z]{2}$/;
      break;
    case 'motorcycle':
      regex = /^[A-Z]\d{3}[A-Z]{3}$|^\d{3}[A-Z]{3}$|^\d{3}[A-Z]{2}$/;
      break;
    default:
      break;
  }

  return regex.test(licensePlate) ? undefined : 'Ingresá una patente válida';
};

export const validatePassword = (value) => {
  const minimumLength = minLength(8, 'Mínimo 8 digitos')(value);
  const minLetter = minOneUppercaseLetter('Mínimo una mayúscula')(value);
  const minDigit = minOneNumber('Mínimo un número')(value);
  const requiredValue = nRequired(value);

  if (requiredValue) {
    return requiredValue;
  }

  if (minimumLength) {
    return minimumLength;
  }

  if (minLetter) {
    return minLetter;
  }

  if (minDigit) {
    return minDigit;
  }

  return undefined;
};
